import { useUserCoupons } from "repositories/hooks";
import { selectCampaignCoupons, selectAvailableCoupons } from "../utils/coupon";
import { FortuneTeller } from "shared/types";

export const useCampaignCoupon = () => {
  const { validCoupons, isLoading } = useUserCoupons();

  const campaignCoupons = selectCampaignCoupons(validCoupons);

  const selectAvailableCouponsFor = (fortuneTeller: FortuneTeller) => {
    return selectAvailableCoupons(validCoupons, fortuneTeller);
  };

  return {
    campaignCoupons,
    selectAvailableCouponsFor,
    isLoading,
  };
};
